// extracted by mini-css-extract-plugin
module.exports = {"signup":"SignupQuick_signup__3z5BE"};